import __request__ from "routing/request";
export function paginated(sort = "title", page = 1, per_page = 15, query, filters, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testNewConnection(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/test", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function upload(type, files, requestOptions) {
  const formData = new FormData();
  files.forEach((f) => formData.append("files", f));
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/upload/${type}`, formData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function importScan(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/${id}/import`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testConnection(id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/${id}/test`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function clear(scannerId, scan_ids, clear_checkpoint = false, clear_assets = false, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/${scannerId}/clear`, null, { "scan_ids": scan_ids, "clear_checkpoint": clear_checkpoint, "clear_assets": clear_assets }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function scheduleImport(scannerId, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp.asset/vulnerability_scanners/${scannerId}/schedule`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
